module.exports = __webpack_public_path__ + "img/player-box.a1a0c2c3.png";